import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { StatusBadge } from '@/components/shared/StatusBadge';
import { ArrowLeft, Check } from 'lucide-react';
import { toast } from 'sonner';

export default function OnboardingPage() {
  const { staffId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({ data: [], total: 0, completed: 0, progress: 0 });

  const refresh = async () => {
    try { const r = await api.get(`/onboarding/staff/${staffId}`); setData(r.data); } catch (e) {}
  };
  useEffect(() => { refresh(); }, [staffId]); // eslint-disable-line

  const complete = async (id) => {
    try { await api.post(`/onboarding/${id}/complete`); toast.success('Task completed'); refresh(); }
    catch (e) { toast.error(e.response?.data?.error?.message || 'Failed'); }
  };

  return (
    <div className="space-y-6 animate-fade-in max-w-3xl">
      <Button variant="ghost" size="sm" onClick={() => navigate(-1)} className="-ml-2"><ArrowLeft className="h-4 w-4 mr-1" /> Back</Button>
      <div className="flex items-center justify-between">
        <div><h1 className="text-2xl font-bold">Onboarding Checklist</h1><p className="text-muted-foreground">{data.completed}/{data.total} tasks completed</p></div>
        <div className="text-right"><p className="text-3xl font-bold text-primary">{data.progress}%</p></div>
      </div>
      <div className="w-full bg-muted rounded-full h-3"><div className="bg-primary h-3 rounded-full transition-all" style={{width:`${data.progress}%`}} /></div>
      <div className="space-y-2">
        {(data.data || []).map(t => (
          <Card key={t.id} className={t.status === 'COMPLETED' ? 'bg-muted/30' : ''}>
            <CardContent className="p-4 flex items-center justify-between">
              <div>
                <p className={`text-sm ${t.status === 'COMPLETED' ? 'line-through text-muted-foreground' : 'font-medium'}`}>{t.title}</p>
                {t.description && <p className="text-xs text-muted-foreground">{t.description}</p>}
                {t.due_date && <p className="text-xs text-muted-foreground">Due: {t.due_date}</p>}
              </div>
              <div className="flex items-center gap-2">
                <StatusBadge status={t.status} />
                {t.status !== 'COMPLETED' && (
                  <Button size="sm" variant="outline" onClick={() => complete(t.id)}><Check className="h-3 w-3 mr-1" /> Complete</Button>
                )}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
